import {
  geGPSApiV1,
  geRXApiV1,
  geVideoApiV1,
  getReactApiV1,
  getCUDBClientApiV1,
  getApiV1 as v1Api,
  getSchedulerApiV1,
  getLocationApiV1,
  getLiveApiV1,
  getBDSApiV1,
  getRootApiV1,
  getWorkflowApiV1,
  getHPDApiV1
} from "../api";
import { getMessagingApiV1 as v1MessageApi } from "../api";
import { parseApiResponse, parseApiResponseJSON } from "../apiError";
import URls from "../../../constants/urls";

export const fetchRequestToken = async (auth0UserId: any) => {
  const response = await v1Api().post(
    "/",
    JSON.stringify({ auth0UserId: auth0UserId })
  );
  return parseApiResponse(response);
};

export const getPosts = async () => {
  const response = await v1Api().get(`/${URls.GET_LIST}`);
  return parseApiResponse(response);
};

export const loginUser = async (payload: { data: any }) => {
  return v1Api()
    .postJson("/login", payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const logoutUser = async (payload: { data: any }) => {
  return v1Api()
    .postJson("/logout", payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const authenticate = async (payload: { data: any }) => {
  return v1Api()
    .postJson("/authenticate", payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const authenticateRoot = async (payload: { data: any }) => {
  return getRootApiV1()
    .postJson("/authenticate", payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};


export const registerUser = async (payload: {
  data?: any;
  email?: any;
  password?: any;
  phoneNumber?: any;
}) => {
  return v1Api()
    .postJson("/register", payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const verifyNewIds = async (payload: { data: any }) => {
  return getRootApiV1()
    .postJson("/verifyNewIds", payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const requestResetPassword = async (payload: {
  data?: any;
  email?: any;
  password?: any;
  phoneNumber?: any;
}) => {
  const { email, password, phoneNumber } = payload;
  return v1Api()
    .postJson("/addAuth", payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const requestResetPasswordRoot = async (payload: {
  data?: any;
}) => {
  return getRootApiV1()
    .postJson("/addAuth", payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const resetPassword = async (payload: {
  data?: any;
  email?: any;
  password?: any;
  phoneNumber?: any;
}) => {
  const { email, password, phoneNumber } = payload;
  return v1Api()
    .postJson("/modifyAuth", payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const modifyIds = async (payload: {
  data?: any;
  email?: any;
  password?: any;
  phoneNumber?: any;
}) => {
  return v1Api()
    .postJson("/modifyIds", payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const getUserInfo = async (payload: { data: any, serviceId?: string }) => {
  return v1Api(payload.serviceId)
    .postJson("/searchInUser", payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const getUserAccount = async (payload: { data: any }) => {
  return v1Api()
    .postJson("/getUserAccount", payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const updateUserInfo = async (payload: { data: any, serviceId?: string }) => {
  return v1Api(payload.serviceId)
    .postJson("/updateUser", payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const getUsersList = async (payload: { data: any }) => {
  return v1Api()
    .postJson(`/searchUser`, payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const getUsersAggregateList = async (payload: { data: any }) => {
  return getBDSApiV1()
    .postJson(`/aggregateBds`, payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const inviteUser = async (payload: { data: any }) => {
  return getHPDApiV1()
    .postJson(`/inviteUser`, payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const getQueryList = async (payload: { data: any }) => {
  return getBDSApiV1()
    .postJson(`/searchInQuery`, payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const createQuery = async (payload: { data: any }) => {
  return getBDSApiV1()
    .postJson(`/createQuery`, payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};


export const uploadMedia = async (payload: any) => {
  return v1MessageApi()
    .postWithoutHeaders("/createMedium", payload)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const uploadMediaV2 = async (payload: any) => {
  return await v1MessageApi()
    .handleFileUpload("/createMedium", payload);
};

export const searchMedia = async (payload: any) => {
  return v1MessageApi()
    .postJson("/searchInMedium", payload)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};


export const getGPSHistoricalData = async (payload: any) => {
  return geGPSApiV1()
    .postJson("/getRange", payload)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const getRXData = async (id: string) => {
  return geRXApiV1()
    .get("page/rx2?deviceId=" + id)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const getVideoSnapshot = async (id: any) => {
  let headers = { APIKey: process.env.REACT_APP_VIDEO_API_KEY };
  return (
    geVideoApiV1()
      .getWithHeaders(
        `/SmartWitness/RESTCommandWebService/ExecuteServerCommand/Snapshots/GetURLs?RecorderID=${id}&CameraChannel=*`,
        headers
      )
      .then((response) => parseApiResponseJSON(response))
      .catch((error) => error.response.data.message)
  );
};

export const getMapPlaces = async (payload: JSON) => {
  return getLocationApiV1()
    .postJson("/geoAggregateLocation", payload)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const getMapPlacesFilter = async (payload: JSON) => {
  return getLocationApiV1()
    .postJson("/searchLocation", payload)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const getLocationProfile = async (payload: JSON) => {
  return getCUDBClientApiV1()
    .postJson(`/searchInUser`, payload)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const getDecryptedPayload = async (payload: JSON) => {
  return getReactApiV1()
    .postJson(`/decryptPayloadTopic`, payload)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const getEncryptedPayload = async (payload: JSON) => {
  return getReactApiV1()
    .postJson(`/encryptPayloadTopic`, payload)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const getSchedule = async (payload: any) => {
  return getSchedulerApiV1()
    .postJson(`/searchSchedule`, payload)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const deleteSchedule = async (payload: any) => {
  return getSchedulerApiV1()
    .postJson(`/deleteSchedule`, payload)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const getPageList = async (payload: { data: any }) => {
  return getLiveApiV1()
    .postJson(`/searchPage`, payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const copyPage = async (payload: { data: any }) => {
  return getLiveApiV1()
    .postJson(`/operatePage`, payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const createPage = async (payload: { data: any; topic: string }) => {
  return getLiveApiV1()
    .postJsonWithHeaders(`/createPage`, payload.data, { topic: payload.topic })
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const getCudbLocationList = async (payload: { data: any }) => {
  return getCUDBClientApiV1()
    .postJson(`/searchUser`, payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const getMediaList = async (payload: { data: any }) => {
  return v1MessageApi()
    .postJson("/searchMedium", payload.data)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};

export const invokeWorkflow = async (payload) => {
  return getWorkflowApiV1()
    .postJson("/invokeWorkflow", payload)
    .then((response) => parseApiResponse(response))
    .catch((error) => error.response.data.message);
};